import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService, UIOrg } from '../auth/service/auth.service';

@Component({
    selector: 'app-people',
    templateUrl: './people.component.html',
    styleUrls: ['./people.component.scss'],
    standalone: false
})
export class DWPeopleComponent implements OnInit {
  isAdmin: Observable<boolean>;
  orgSettings: Observable<UIOrg | undefined>;

  constructor(private auth: AuthService) {}

  ngOnInit() {
    this.isAdmin = this.auth.$isAdmin;
    this.orgSettings = this.auth.$getSelectedOrg;
  }
}
